import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { TextKey } from '@mews-commander/enums';
import { useCultureCode } from '@mews-commander/core';
import { LocalizedCurrencyValue } from '@mews/framework';
import { getCurrencyLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { useCommanderSelector } from '@mews-commander/utils';
import { HighlightCard } from '../../../../common/HighlightCard';
import { WidgetCardsWrapper } from '../../../../common/WidgetCardsWrapper';
import { AgeingCard } from '../AgeingCard';
import { InvoiceStatusCard } from '../InvoiceStatusCard';
import { useCityLedgerHighlights } from '../../../hooks/useCityLedgerHighlights';
import { useCityLedgerSelectedDate } from '../../../context/CityLedgerFilterContext';

export const WidgetCards = () => {
    const enterprise = useCurrentEnterprise();
    const { selectedDate } = useCityLedgerSelectedDate();

    const {
        data: { outstandingBalance = null, statusDistribution = null, ageingDistribution = null } = {},
        isLoading,
        error,
    } = useCityLedgerHighlights();

    const cultureCode = useCultureCode();

    const currencyLocalizationInfo = useCommanderSelector((state) =>
        getCurrencyLocalizationInfo(state, { cultureCode, currencyCode: enterprise.defaultCurrencyCode })
    );

    return (
        <WidgetCardsWrapper cardMaxWidth="33%">
            <HighlightCard
                title={TextKey.OutstandingBalance}
                date={selectedDate}
                content={<LocalizedCurrencyValue value={outstandingBalance} />}
                loading={isLoading}
                error={error}
            />
            <InvoiceStatusCard data={statusDistribution} loading={isLoading} error={error} date={selectedDate} />
            <AgeingCard
                currencySymbol={currencyLocalizationInfo.symbol}
                data={ageingDistribution}
                loading={isLoading}
                error={error}
                date={selectedDate}
            />
        </WidgetCardsWrapper>
    );
};
